<template>
	<div>
		<div v-for="group in groups" :key="group.id">
			<GroupDataRow :group="group" :groupData="groupData(group)" isShowNamePath :projectId="projectId"> </GroupDataRow>
		</div>
	</div>
</template>

<script>
import GroupDataRow from '../DataRow/GroupDataRow';

export default {
	name: 'GroupDataList',
	components: { GroupDataRow },
	props: {
		groups: { type: Array, required: true },
		isShowNamePath: { type: Boolean },
		sharedData: { type: Array },
		projectId: { type: Number },
	},
	methods: {
		groupData(group) {
			return this.sharedData.find((g) => g.id === group.id);
		},
	},
};
</script>

<style scoped lang="scss"></style>
